module.exports = "<footer id=\"footer\">\n  <video id=\"video\" autoplay muted loop controls>\n    <source src=\"./assets/footer_bg.mp4\" type=\"video/mp4\">\n  </video>\n  <div class=\"container\" id=\"container\">\n    <p class=\"float-right\">\n    </p>\n    <p>\n      <img class=\"img-fluid\" [src]=\"(item | async)?.footer_image.url | img\">\n    </p>\n    <p>Copyright© 2018 Luiz Nishimori\n      <br> Todos os direitos reservados.</p>\n  </div>\n</footer>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/footer/footer.component.html
// module id = ./src/app/footer/footer.component.html
// module chunks = main